<template>
  <v-card
    id="project-card"
    @click="goToProjectInfo"
    :style="{
      border: '1px solid var(--primary-boarder-color)',
    }"
  >
    <div class="ma-5 pa-5 mb-2 pb-0">
      <v-row justify="space-between">
        <div class="d-flex align-center">
          {{ formatDate(project.start_date) }}
        </div>
      </v-row>
      <v-col class="d-flex align-center justify-center flex-column mt-2">
        <div class="truncate font-weight-medium project-name text-h6">
          {{ project.project_name }}
        </div>
        <div v-if="project.project_type" class="truncate">
          {{ project.project_type.name }}
        </div>
        <div v-else class="truncate">&nbsp;</div>
      </v-col>
      <v-col>
        <p class="font-weight-medium">Progress</p>
        <v-row class="ma-1 mx-0">
          <v-progress-linear
            :value="project.progress"
            color="var(--color-primary-blue)"
            height="5"
            class="progress-liner"
          ></v-progress-linear>
        </v-row>
        <v-row class="justify-end">
          <p class="font-weight-medium">{{ project.progress }}%</p>
        </v-row>
      </v-col>
    </div>
    <v-divider class="my-1"></v-divider>
    <v-card-actions class="mx-5 my-3">
      <avatar-group
        :avatars="
          project.members.map((member) => ({
            profile_image: member.profile_image,
            full_name: member.employer.full_name,
          }))
        "
      />
      <v-spacer></v-spacer>
      <v-chip
        color="var(--color-primary-blue-light)"
        text-color="var(--color-primary-blue)"
      >
        {{ remainingTime(project.due_date) }}
      </v-chip>
    </v-card-actions>
  </v-card>
</template>

<script>
import AvatarGroup from "@/components/shared/AvatarGroup";

export default {
  name: "ProjectCard",
  props: {
    project: {
      type: Object,
      required: true,
    },
  },
  components: {
    AvatarGroup,
  },
  data: () => ({
    defaultImage: require("@/assets/img/avatar.svg"),
  }),
  methods: {
    remainingTime(date) {
      const dueDate = new Date(date);
      const now = new Date();
      const timeDiff = dueDate - now;
      const daysLeft = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
      const hoursLeft = Math.floor(
        (timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );

      if (daysLeft >= 365) {
        const yearsLeft = Math.floor(daysLeft / 365);
        return `${yearsLeft} year${yearsLeft > 1 ? "s" : ""} left`;
      } else if (daysLeft >= 30) {
        const monthsLeft = Math.floor(daysLeft / 30);
        return `${monthsLeft} month${monthsLeft > 1 ? "s" : ""} left`;
      } else if (daysLeft >= 7) {
        const weeksLeft = Math.floor(daysLeft / 7);
        return `${weeksLeft} week${weeksLeft > 1 ? "s" : ""} left`;
      } else if (daysLeft > 1) {
        return `${daysLeft} days left`;
      } else if (daysLeft === 1) {
        return `1 day left`;
      } else if (daysLeft === 0) {
        return `${hoursLeft} hour${hoursLeft !== 1 ? "s" : ""} left`;
      } else {
        return "Overdue";
      }
    },
    goToProjectInfo() {
      const uuid = this.project.uuid;
      this.$router.push({ name: "ProjectInfo", params: { uuid } });
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      const options = { year: "numeric", month: "long", day: "numeric" };
      return new Intl.DateTimeFormat("en-US", options).format(date);
    },
  },
};
</script>
